import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { hide, callbackRequest } from 'store/modules/dialog/actions';
import { DialogContainer } from './styles';

const Dialog: React.FC = () => {
  //react-router-dom
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    show,
    title,
    type,
    text,
    maxlength,
    inputType,
    inputValue,
    contentHTML,
    timer,
    allowOutsideClick,
    successMessage,
    confirmButtonText,
    cancelButtonText,
    showCancelButton,
    showConfirmButton,
    showCloseButton,
    showLoading,
    callback,
    redirectTo,
  } = useSelector((state: any) => state.dialog);

  const handleClose = useCallback(() => {
    if (redirectTo) {
      if (redirectTo === 'goBack') navigate(-1);
      navigate(redirectTo);
    }
    dispatch(hide());
  }, [dispatch, redirectTo]);

  const handleConfirm = useCallback(
    (result: any) => {
      if (result.value) {
        if (!!callback && !!callback.method) {
          dispatch(callbackRequest({ mensagem: result.value, successMessage }));
        } else {
          if (!!callback && !!callback.onClose) {
            callback.onClose();
          } else {
            dispatch(hide());
          }
        }
      } else {
        if (
          !!result.dismiss &&
          !['close', 'backdrop'].includes(result.dismiss) &&
          !!callback &&
          !!callback.onClose
        ) {
          callback.onClose();
        }
        dispatch(hide());
      }
    },
    [callback, dispatch, successMessage],
  );

  const inputAttributes = {
    placeholder: 'Escreva aqui sua observação *',
    required: 'true',
    maxlength: maxlength,
  };

  return (
    <DialogContainer
      show={show}
      title={title}
      text={text}
      type={type || ''}
      html={contentHTML || ''}
      timer={timer}
      input={inputType}
      inputValue={inputValue}
      allowOutsideClick={allowOutsideClick}
      onError={() => console.log('Erro no Dialog')}
      inputAttributes={inputAttributes}
      showLoading={showLoading}
      showCloseButton={showCloseButton}
      showConfirmButton={showConfirmButton}
      showCancelButton={showCancelButton}
      confirmButtonText={confirmButtonText || 'OK'}
      cancelButtonText={cancelButtonText || 'FECHAR'}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );
};

export default Dialog;
